<coop-offer-form
  [editMode]="false"
  [templateMode]="true"
  [formData]="formData"
></coop-offer-form>
